







































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Api
import { mapData, WEBHOOK_API_MAPPING } from '@/api/Mapping'

// Mixins
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

// Components
import MultipleSelector from '@/components/common/MultipleSelector.vue'

@Component({
  components: {
    MultipleSelector
  }
})
export default class WebhookLine extends Mixins(Form, Errors) {
  @Prop({ type: Object, default: null }) webhook
  @Prop({ type: Boolean, default: false }) canRemove
  @Prop({ type: Boolean, default: false }) save

  selectorUpdated = false

  @Getter('token') token

  @Watch('save')
  async saveLine(save) {
    if (save && this.lineHasChanged) {
      try {
        this.$emit('saving', true)
        if (this.webhook.id) {
          await this.updateWebhook()
        } else {
          await this.createWebhook()
        }
      } catch (error) {
        this.displayErrors(error)
      } finally {
        this.$emit('saved')
        this.$emit('saving', false)
      }
    }
  }

  @Watch('lineHasChanged')
  updateMainSave(lineHasChanged) {
    if (lineHasChanged) {
      this.$emit('change')
    }
  }

  get lineHasChanged() {
    return this.formUpdated || this.selectorUpdated
  }

  get choices() {
    return [
      {
        label: this.$t('company.webhook.events.report.creation'),
        value: 'init'
      },
      {
        label: this.$t('company.webhook.events.report.endinit'),
        value: 'firstFinished'
      },
      {
        label: this.$t('company.webhook.events.report.endfinal'),
        value: 'secondFinished'
      },
      {
        label: this.$t('company.webhook.events.report.update'),
        value: 'update'
      }
    ]
  }

  webhookEvents(webhook) {
    const values = []
    const entries = Object.entries(webhook)

    for (const entry of entries) {
      if (typeof(entry[1]) === 'boolean' && entry[1] === true) {
        values.push(entry[0])
      }
    }
    return values
  }

  udpateEvent(webhook, event) {
    this.selectorUpdated = true
    for (const [entry, value] of Object.entries(webhook)) {
      if (typeof(value) === 'boolean' && value === true) {
        webhook[entry] = false
      }
    }

    for (const key of event) {
      webhook[key] = true
    }
  }

  deleteLine() {
    if (this.canRemove) {
      this.$emit('delete')
      return
    }

    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('webhook.actions.delete.message') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          this.$emit('saving', true)
          await this.$api.webhooks.deleteWebhook(this.token, this.webhook.id)
          this.$emit('reload')
          this.$toast.open({
            type: 'is-success',
            message: this.$t('team.actions.delete.success') as string
          })
        } catch (error) {
          this.displayErrors(error)
        } finally {
          this.$emit('saving', false)
        }
      }
    })
  }

  async updateWebhook() {
    await this.$api.webhooks.updateWebhook(
      this.token,
      this.webhook.id,
      mapData(WEBHOOK_API_MAPPING, this.webhook, true, false)
    )
  }

  async createWebhook() {
    await this.$api.webhooks.createWebhook(
      this.token,
      mapData(WEBHOOK_API_MAPPING, this.webhook, true, false)
    )
  }
}
